import { AxiosRequestConfig, createInstance } from '@tencent/oneid-request';
import i18n from 'common/locales';
import { onError, onSuccess } from './Interceptors';

const createAxiosInstance = (config: AxiosRequestConfig) => {
  const axiosInstance = createInstance(config);

  axiosInstance.interceptors.request.use((reqConfig) => {
    // eslint-disable-next-line no-param-reassign
    reqConfig.headers['Accept-Language'] = i18n.language;
    return reqConfig;
  });

  axiosInstance.interceptors.response.use(
    (response) => {
      return onSuccess(response);
    },
    (error) => {
      return onError(error);
    },
  );

  return axiosInstance;
};

export default createAxiosInstance;
